/* ==========================================================================
   Craft Quest — product page
   - Media gallery with cross-fade, thumbs, arrows, dots, swipe, zoom
   - Variant picker: price / SKU / stock / URL / gallery sync
   - AJAX add to cart (reuses the shared cart drawer) + Buy now
   Tabs and the review carousel are handled by cq-sections.js.
   ========================================================================== */
(function () {
  if (window.__cqProduct) return;
  window.__cqProduct = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function CQ() { return window.CQ || {}; }

  var pdp = document.querySelector('[data-cq-pdp]');
  if (!pdp) return;

  /* ---------------- Money ---------------- */
  function money(cents) {
    var fmt = (window.Shopify && window.Shopify.money_format) || '₹{{amount}}';
    var withDec = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDec = String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals[^}]*\}\}/g, noDec)
      .replace(/\{\{\s*amount[^}]*\}\}/g, withDec);
  }

  /* ---------------- Gallery ---------------- */
  var gallery = (function () {
    var stage = pdp.querySelector('[data-cq-stage]');
    if (!stage) return null;
    var slides = Array.prototype.slice.call(stage.querySelectorAll('[data-cq-slide]'));
    if (!slides.length) return null;
    var thumbs = Array.prototype.slice.call(pdp.querySelectorAll('[data-cq-thumb]'));
    var current = 0;

    function pauseMedia(slide) {
      slide.querySelectorAll('video, iframe').forEach(function (el) {
        if (el.tagName === 'VIDEO') { try { el.pause(); } catch (e) { /* ignore */ } }
      });
    }

    function go(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      if (index === current) return;

      var from = slides[current], to = slides[index];
      pauseMedia(from);
      // Cross-fade: incoming fades in while outgoing fades out (both briefly visible)
      to.classList.add('is-entering');
      to.removeAttribute('aria-hidden');
      requestAnimationFrame(function () {
        to.classList.add('is-active');
        from.classList.remove('is-active');
        from.setAttribute('aria-hidden', 'true');
        setTimeout(function () { to.classList.remove('is-entering'); }, 400);
      });

      current = index;
      thumbs.forEach(function (t) {
        var on = parseInt(t.dataset.cqThumb, 10) === index;
        t.classList.toggle('is-active', on);
        if (on) revealThumb(t);
      });
    }

    // Keep the active thumbnail visible by scrolling ONLY its own thumbs track.
    // (scrollIntoView was used here before, but it also scrolls every ancestor,
    // including overflow:hidden page wrappers. That shifted the whole page up
    // and left a blank white area whenever a variant changed the image.)
    function revealThumb(t) {
      var track = t.closest('[data-cq-thumbs-track]');
      if (!track || !t.offsetParent) return; // dots / hidden thumbs: nothing to scroll
      var tr = track.getBoundingClientRect();
      var r = t.getBoundingClientRect();
      var dy = 0, dx = 0;
      if (r.top < tr.top) dy = r.top - tr.top;
      else if (r.bottom > tr.bottom) dy = r.bottom - tr.bottom;
      if (r.left < tr.left) dx = r.left - tr.left;
      else if (r.right > tr.right) dx = r.right - tr.right;
      if (!dx && !dy) return;
      try { track.scrollBy({ top: dy, left: dx, behavior: 'smooth' }); }
      catch (e) { track.scrollTop += dy; track.scrollLeft += dx; }
    }

    function goToMediaId(id) {
      var i = slides.findIndex(function (sl) { return sl.dataset.mediaId === String(id); });
      if (i > -1) go(i);
    }

    // Thumbs, arrows, dots
    pdp.addEventListener('click', function (e) {
      var t = e.target.closest('[data-cq-thumb]');
      if (t) { e.preventDefault(); go(parseInt(t.dataset.cqThumb, 10)); return; }
      if (e.target.closest('[data-cq-gallery-prev]')) { go(current - 1); return; }
      if (e.target.closest('[data-cq-gallery-next]')) { go(current + 1); return; }
      var more = e.target.closest('[data-cq-thumbs-next]');
      if (more) {
        var track = pdp.querySelector('[data-cq-thumbs-track]');
        if (track) track.scrollBy({ top: track.clientHeight * 0.6, behavior: 'smooth' });
      }
    });

    // Keyboard
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
    });
    stage.setAttribute('tabindex', '0');

    // Swipe
    var x0 = null, y0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(current + (dx < 0 ? 1 : -1));
      x0 = y0 = null;
    }, { passive: true });

    // Zoom (desktop hover pan, mobile tap toggle)
    pdp.querySelectorAll('[data-cq-zoom]').forEach(function (z) {
      var img = z.querySelector('img');
      if (!img) return;
      function pan(e) {
        var r = z.getBoundingClientRect();
        var px = ((e.clientX - r.left) / r.width) * 100;
        var py = ((e.clientY - r.top) / r.height) * 100;
        img.style.transformOrigin = px + '% ' + py + '%';
      }
      if (window.matchMedia('(hover: hover)').matches) {
        z.addEventListener('mouseenter', function () { z.classList.add('is-zoomed'); });
        z.addEventListener('mousemove', pan);
        z.addEventListener('mouseleave', function () { z.classList.remove('is-zoomed'); img.style.transformOrigin = 'center'; });
      } else {
        z.addEventListener('click', function () { z.classList.toggle('is-zoomed'); });
      }
    });

    return { go: go, goToMediaId: goToMediaId };
  })();

  /* ---------------- Variants ---------------- */
  (function variants() {
    var json = pdp.querySelector('[data-cq-variants]');
    if (!json) return;
    var all;
    try { all = JSON.parse(json.textContent); } catch (e) { return; }
    if (!all || !all.length) return;

    var idInput = pdp.querySelector('[data-cq-variant-input]');
    var priceBox = pdp.querySelector('[data-cq-price]');
    var skuBox = pdp.querySelector('[data-cq-sku]');
    var stockBox = pdp.querySelector('[data-cq-stock]');
    var addBtn = pdp.querySelector('[data-cq-pdp-add]');
    var buyBtn = pdp.querySelector('[data-cq-buy-now]');
    var current = all.find(function (v) { return String(v.id) === String(idInput && idInput.value); }) || all[0];

    function selected() {
      var out = [];
      pdp.querySelectorAll('[data-cq-option-index]').forEach(function (fs) {
        var checked = fs.querySelector('[data-cq-option-value]:checked');
        out.push(checked ? checked.value : null);
      });
      return out;
    }

    function match(opts) {
      return all.find(function (v) {
        return opts.every(function (o, i) { return o === null || v.options[i] === o; });
      });
    }

    // Show each first-option value's price on its chip (e.g. sizes)
    function paintOptionPrices() {
      pdp.querySelectorAll('[data-cq-option-price]').forEach(function (el) {
        var fs = el.closest('[data-cq-option-index]');
        if (!fs || parseInt(fs.dataset.cqOptionIndex, 10) !== 1) { el.textContent = ''; return; }
        var value = el.dataset.cqOptionPrice;
        var v = all.find(function (x) { return x.options[0] === value; });
        el.textContent = v ? money(v.price) : '';
      });
    }

    function markUnavailable(opts) {
      pdp.querySelectorAll('[data-cq-option-index]').forEach(function (fs) {
        var idx = parseInt(fs.dataset.cqOptionIndex, 10) - 1;
        fs.querySelectorAll('[data-cq-option-value]').forEach(function (input) {
          var probe = opts.slice();
          probe[idx] = input.value;
          var v = match(probe);
          var label = fs.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    function apply(v) {
      current = v;
      if (!v) {
        if (addBtn) {
          addBtn.disabled = true;
          var l0 = addBtn.querySelector('[data-cq-atc-label]');
          if (l0) l0.textContent = 'Unavailable';
        }
        if (buyBtn) buyBtn.disabled = true;
        return;
      }

      if (idInput) idInput.value = v.id;

      if (priceBox) {
        var html = '<span class="cq-pdp__price-current">' + money(v.price) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += '<s class="cq-pdp__price-compare">' + money(v.compare_at_price) + '</s>';
          html += '<span class="cq-pdp__price-save">' + Math.round((1 - v.price / v.compare_at_price) * 100) + '% off</span>';
        }
        priceBox.innerHTML = html;
      }

      if (skuBox) skuBox.textContent = v.sku ? 'SKU: ' + v.sku : '';

      if (stockBox) {
        var dot = stockBox.querySelector('.cq-pdp__stock-dot');
        var strong = stockBox.querySelector('strong');
        if (dot) dot.classList.toggle('is-out', !v.available);
        if (strong) strong.textContent = v.available ? (stockBox.dataset.inText || 'In Stock') : (stockBox.dataset.outText || 'Out of Stock');
      }

      if (addBtn) {
        addBtn.disabled = !v.available;
        var l = addBtn.querySelector('[data-cq-atc-label]');
        if (l) l.textContent = v.available ? (addBtn.dataset.addLabel || 'Add to Cart') : 'Sold Out';
      }
      if (buyBtn) buyBtn.disabled = !v.available;

      if (v.featured_media && gallery) gallery.goToMediaId(v.featured_media.id);

      if (history.replaceState) {
        var url = new URL(location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }

      document.dispatchEvent(new CustomEvent('cq:variant-change', { detail: { variant: v, productId: pdp.dataset.productId } }));
    }

    // Remember the original labels before the first swap
    if (addBtn) {
      var lbl = addBtn.querySelector('[data-cq-atc-label]');
      addBtn.dataset.addLabel = lbl ? lbl.textContent.trim() : 'Add to Cart';
    }
    if (stockBox) {
      var st = stockBox.querySelector('strong');
      stockBox.dataset.inText = st ? st.textContent.trim() : 'In Stock';
      stockBox.dataset.outText = 'Out of Stock';
    }

    pdp.addEventListener('change', function (e) {
      if (!e.target.closest('[data-cq-option-value]')) return;
      var opts = selected();
      markUnavailable(opts);
      apply(match(opts));
    });

    paintOptionPrices();
    markUnavailable(selected());
  })();

  /* ---------------- Quantity ---------------- */
  pdp.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cq-pdp-qty]');
    if (!btn) return;
    var input = pdp.querySelector('[data-cq-pdp-qty-input]');
    if (!input) return;
    var next = (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.cqPdpQty, 10);
    input.value = Math.max(1, next);
  });

  /* ---------------- Add to cart / Buy now ---------------- */
  function payload() {
    var idInput = pdp.querySelector('[data-cq-variant-input]');
    var qty = pdp.querySelector('[data-cq-pdp-qty-input]');
    return { id: Number(idInput && idInput.value), quantity: Math.max(1, parseInt(qty && qty.value, 10) || 1) };
  }

  function sectionIds() {
    if (CQ().cartSectionIds) return CQ().cartSectionIds();
    var ids = [];
    document.querySelectorAll('[data-cq-section]').forEach(function (el) {
      var id = el.getAttribute('data-cq-section');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  /* Buy now: a real form POST to /cart/add with return_to=/checkout.
     A browser navigation is used (not fetch) so the browser goes straight to
     checkout — no drawer, no AJAX race. */
  function buyNow() {
    var btn = pdp.querySelector('[data-cq-buy-now]');
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    var data = payload();
    var f = document.createElement('form');
    f.method = 'post';
    f.action = root + 'cart/add';
    f.style.display = 'none';
    [['id', data.id], ['quantity', data.quantity], ['return_to', '/checkout']].forEach(function (pair) {
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = pair[0];
      i.value = pair[1];
      f.appendChild(i);
    });
    document.body.appendChild(f);
    f.submit();
  }

  function add() {
    var btn = pdp.querySelector('[data-cq-pdp-add]');
    if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;
    var label = btn.querySelector('[data-cq-atc-label]');
    var original = label ? label.textContent : '';
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Adding…';

    var body = { items: [payload()] };
    var ids = sectionIds();
    if (ids.length) body.sections = ids.join(',');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) throw new Error(res.json.description || res.json.message || 'Could not add to cart');

        // Re-render the drawer + header counts directly. (Dispatching cart:update
        // would be ignored here, because the shared script skips its own events.)
        if (CQ().syncCart) CQ().syncCart(res.json.sections, res.json.item_count);
        else if (CQ().setCartCount && typeof res.json.item_count === 'number') CQ().setCartCount(res.json.item_count);

        if (CQ().openCart) CQ().openCart();
        else if (CQ().toast) CQ().toast('Added to cart. <a href="' + root + 'cart">View cart</a>');

        btn.classList.add('is-added');
        if (label) label.textContent = 'Added ✓';
        setTimeout(function () { btn.classList.remove('is-added'); if (label) label.textContent = original; }, 1800);
      })
      .catch(function (err) {
        if (CQ().toast) CQ().toast(err.message, true);
        if (label) label.textContent = original;
      })
      .finally(function () { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); });
  }

  var form = pdp.querySelector('[data-cq-product-form]');
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
  pdp.addEventListener('click', function (e) {
    if (e.target.closest('[data-cq-buy-now]')) { e.preventDefault(); buyNow(); }
  });
})();
